import { Tooltip } from 'react-tooltip'
import { useMemo } from "react";
import { ActionButton } from "../../chat-actions/styles";
import { useAppDispatch, useAppSelector } from '../../../../common/store';
import { VideoIcon } from '../../../components/icons/chat-actions/video-icon';
import { VideoOffIcon } from '../../../components/icons/chat-actions/video-off-icon';
import { MicOffIcon } from '../../../components/icons/chat-actions/mic-off-icon';
import { MicIcon } from '../../../components/icons/chat-actions/mic-icon';
import { CallActionsContainer } from './styles';
import { endCall, toggleCamera, toggleMic } from '../../../../common/store/calls/calls-slice';
import { EndCallIcon } from '../../../components/icons/chat-actions/end-call-icon';
import { sendEndCall } from '../../../../common/store/calls/thunks/send-end-call';

const CallActions = () => {
  const dispatch = useAppDispatch();
  const isMicOn = useAppSelector(state => state.calls.isMicOn);
  const isCameraOn = useAppSelector(state => state.calls.isCameraOn);

  const onClickAction = (id: string) => {
    switch (id) {
      case 'end-call':
        // TODO
        dispatch(sendEndCall());
        dispatch(endCall());
        return;
      case 'mute-video':
        dispatch(toggleCamera(false));
        return;
      case 'unmute-video':
        dispatch(toggleCamera(true));
        return;
      case 'mute-mic':
        dispatch(toggleMic(false));
        return;
      case 'unmute-mic':
        dispatch(toggleMic(true));
        return;
      default:
        return;
    }
  }

  const actions = useMemo(() => {
    const result = [
      {
        id: isCameraOn ? 'mute-video' : 'unmute-video',
        icon: isCameraOn ? <VideoIcon /> : <VideoOffIcon />,
        tooltip: isCameraOn ? 'Turn Video Off' : 'Turn Video On',
      },
      {
        id: isMicOn ? 'mute-mic' : 'unmute-mic',
        icon: isMicOn ? <MicIcon /> : <MicOffIcon />,
        tooltip: isMicOn ? 'Turn Mic Off' : 'Turn Mic On',
      },
      {
        id: 'end-call',
        icon: <EndCallIcon />,
        tooltip: 'End call',
      },
    ]

    return result;
  }, [isMicOn, isCameraOn])

  return (
    <CallActionsContainer>
      {actions.map(action => (
        <div key={action.id}>
          <ActionButton onClick={() => onClickAction(action.id)} data-tooltip-id={`${action.id}-tooltip`}>
            {action.icon}
          </ActionButton>
          <Tooltip
            id={`${action.id}-tooltip`}
            content={action.tooltip}
            place='bottom'
            style={{
              zIndex: 99999999
            }}
          />
        </div>
      ))}
    </CallActionsContainer>
  )
}

export default CallActions;
